import {useApiEndpoint} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornService} from "../../../../../application/business/StubbornAsset";

export const useEditionServiceApi = () => useApiEndpoint<StubbornService>(PATH);
